function SquareBoxPendingIco() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2017_190630)">
        <path
          d="M2 11C2 5.47715 6.47715 1 12 1H40C45.5229 1 50 5.47715 50 11V39C50 44.5229 45.5228 49 40 49H12C6.47715 49 2 44.5228 2 39V11Z"
          fill="#FEEFC6"
          shape-rendering="crispEdges"
        />
        <path
          d="M28.8712 14.1375C28.7855 14.0495 28.6681 14 28.5453 14H23.4545C23.3317 14 23.2142 14.0498 23.1286 14.1375C23.0427 14.2252 22.9968 14.3443 23.0002 14.467L23.382 28.2834C23.3885 28.5293 23.5901 28.725 23.8362 28.725H28.1645C28.4106 28.725 28.6124 28.5293 28.6187 28.283L28.9998 14.467C29.003 14.3445 28.9569 14.2254 28.8712 14.1375Z"
          fill="#DC6803"
        />
        <path
          d="M28.1554 31.0547H23.8451C23.5942 31.0547 23.3906 31.2583 23.3906 31.5092V35.4952C23.3906 35.7461 23.5942 35.9497 23.8451 35.9497H28.1559C28.4067 35.9497 28.6104 35.7461 28.6104 35.4952V31.5092C28.6099 31.2583 28.4067 31.0547 28.1554 31.0547Z"
          fill="#DC6803"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2017_190630"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2017_190630"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2017_190630"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default SquareBoxPendingIco;
